import Vue from 'vue';
import Router from 'vue-router';
import Wizard from './views/Wizard.vue';
import Creating from './views/Creating.vue';
import Auth from './views/Auth.vue';
import Preview from './views/Preview.vue';
import Payment from './views/Payment.vue';
import MobilePayment from './views/MobilePayment.vue';
import Success from './views/Success.vue';
import Publishing from './views/Publishing.vue';
import { YANDEX_METRIKA_CODE } from '@/constants/metrika';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'wizard',
      component: Wizard,
    },
    {
      path: '/creating',
      name: 'creating',
      component: Creating,
      props: route => ({ data: route.params.data }),
    },
    {
      path: '/auth',
      name: 'auth',
      component: Auth,
      props: route => ({ data: route.params.data }),
    },
    {
      path: '/preview',
      name: 'preview',
      component: Preview,
    },
    {
      path: '/payment',
      name: 'payment',
      component: Payment,
    },
    {
      path: '/mobile-payment',
      name: 'mobile-payment',
      component: MobilePayment,
    },
    {
      path: '/publishing',
      name: 'publishing',
      component: Publishing,
    },
    {
      path: '/success',
      name: 'success',
      component: Success,
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (window.ym) {
    window.ym(YANDEX_METRIKA_CODE, 'reachGoal', `open-${to.name}`);
  }
  if (window.gtag) {
    window.gtag('event', 'change', { event_category: 'Router', event_label: to.name });
  }
  if (to.name === 'publishing' && window.fbq) {
    window.fbq('track', 'Purchase');
  }
  next();
});

export default router;
